module.exports = __webpack_public_path__ + "img/months-settings.0ff9ee20.svg";